import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const BookOpen20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path
      d='M17.2278 7.31809C17.3282 7.71993 17.0839 8.12714 16.6821 8.2276L12.6821 9.2276C12.2802 9.32806 11.873 9.08374 11.7726 8.68189C11.6721 8.28005 11.9164 7.87284 12.3183 7.77238L16.3183 6.77238C16.7201 6.67192 17.1273 6.91624 17.2278 7.31809Z'
      fill='currentColor'
    />
    <path
      d='M16.6821 12.2276C17.0839 12.1271 17.3282 11.7199 17.2278 11.3181C17.1273 10.9162 16.7201 10.6719 16.3183 10.7724L12.3183 11.7724C11.9164 11.8728 11.6721 12.28 11.7726 12.6819C11.873 13.0837 12.2802 13.3281 12.6821 13.2276L16.6821 12.2276Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.1627 1.76786C0.701621 1.6654 0.25 2.02768 0.25 2.5V15.5C0.25 15.8515 0.494149 16.1559 0.837302 16.2321L9.8373 18.2321C9.94446 18.256 10.0555 18.256 10.1627 18.2321L19.1627 16.2321C19.5059 16.1559 19.75 15.8515 19.75 15.5V2.5C19.75 2.02768 19.2984 1.6654 18.8373 1.76786L10 3.73171L1.1627 1.76786ZM1.75 14.8984V3.43496L9.25 5.10163V16.565L1.75 14.8984ZM10.75 16.565L18.25 14.8984V3.43496L10.75 5.10163V16.565Z'
      fill='currentColor'
    />
  </Svg>
);

BookOpen20.displayName = 'BookOpen20';
export default BookOpen20;
